const docEl = document.documentElement;
const dpr = window.devicePixelRatio || 1;
const width = docEl.clientWidth;
const height = docEl.clientHeight;
const pixel = width * dpr + 'x' + height * dpr;

const ua = navigator.userAgent;

const isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isAdr = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
const isWx = !!ua.match(/MicroMessenger/i);

export {
	dpr,
	width,
	height,
	pixel,
	isIos,
	isAdr,
	isWx
};


// WEBPACK FOOTER //
// ./src/constants/device.js